import { render, staticRenderFns } from "./ConsultaLogNotaFiscal.vue?vue&type=template&id=4bd112d8"
import script from "./ConsultaLogNotaFiscal.vue?vue&type=script&lang=js"
export * from "./ConsultaLogNotaFiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports